module.exports = __webpack_public_path__ + "static/media/Header_img_big.0d4f2729.webp";